import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { default as ConsultationListContainer } from '../Project/ProjectListContainer';
import { default as ConsultationCardPreviewContainer } from './ConsultationCardPreviewContainer';
import { default as ConsultationCardVoteContainer } from './ConsultationCardVoteContainer';
import { RouteUrls } from '../../../configs/routeUrls';
import { ProjectType } from '../../../utils/enums';

export class Consultation extends Component {
	render() {
		return (
			<div>
				<div>{this.props.children}</div>
				<Route
					exact
					path={RouteUrls.Consultation.list.actual}
					render={(props) => (
						<ConsultationListContainer
							{...props}
							type={ProjectType.Consultation}
							listUrl={RouteUrls.Consultation.list.actual}
							voteUrl={RouteUrls.Consultation.vote}
							previewUrl={RouteUrls.Consultation.preview}
						/>
					)}
				/>
				<Route
					exact
					path={RouteUrls.Consultation.list.finished}
					render={(props) => (
						<ConsultationListContainer
							{...props}
							type={ProjectType.Consultation}
							listUrl={RouteUrls.Consultation.list.actual}
							voteUrl={RouteUrls.Consultation.vote}
							previewUrl={RouteUrls.Consultation.preview}
						/>
					)}
				/>
				<Route path={`${RouteUrls.Consultation.preview}/:id`} component={ConsultationCardPreviewContainer} />
				<Route path={`${RouteUrls.Consultation.vote}/:id`} component={ConsultationCardVoteContainer} />
			</div>
		);
	}
}
